// Available colors to be used in different themes as the 'primary' and 'secondary' colors
// for buttons, headings, etc.
//
// The color classes are dynamically determined in some of the components (e.g. the Button
// component), so tailwind isn't able to determine which classes are needed at build time
// without JIT compilation (which isn't suitable for a component library). That's why we
// need to add these classes to the safelist - see tailwind.config.ts.

export const availablePrimaryColors = ['black', 'brand-blue'] as const
export const availablePrimaryHoverColors = [
    'state-hover',
    'blue-theme-hover',
] as const

// Note: as of 1/11/24, secondary colors are not in use anywhere, but we're leaving them here
// in anticipation that they will probably be used as we build out a partially themeable library.
export const availableSecondaryColors = ['white', 'black'] as const
